module.exports = __webpack_public_path__ + "img/uni.f11a5f40.jpg";